import * as tslib_1 from "tslib";
import { action } from 'satcheljs/lib/legacy';
import setMailboxForwardingConfiguration from '../services/setMailboxForwardingConfiguration';
import store from '../store/store';
export default action('saveMailboxForwardingConfiguration')(function saveMailboxForwardingConfiguration(mailboxForwardingConfiguration) {
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        return tslib_1.__generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    store.mailboxForwardingConfiguration = mailboxForwardingConfiguration;
                    return [4 /*yield*/, setMailboxForwardingConfiguration(mailboxForwardingConfiguration)];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    });
});
//# sourceMappingURL=saveMailboxForwardingConfiguration.js.map